import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

interface ProtectedRouteProps {
  children: React.ReactNode;
  allowedRoles?: string[];
}

export default function ProtectedRoute({ children, allowedRoles }: ProtectedRouteProps) {
  const { isAuthenticated, user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="app-shell flex items-center justify-center min-h-screen">
        <div className="w-10 h-10 rounded-full border-4 border-slate-200/80 border-t-slate-950 animate-spin" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (allowedRoles && user && !allowedRoles.includes(user.role)) {
    return (
      <div className="app-shell flex min-h-screen items-center justify-center px-4">
        <div className="glass-card max-w-md p-8 text-center">
          <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-2xl bg-red-50 text-xl text-red-500">⛔</div>
          <div className="text-xl font-semibold text-slate-950 mb-2">无权限访问此页面</div>
          <p className="text-slate-500">您的角色无法查看此内容</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
